import React from 'react';
import { TableRow, TableCell, Typography, TableHead, Tooltip } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import OverdueChip from '../OverdueChip';
import MultipleProgressBar from '../../CustomComponents/MultipleProgressBar';
import { theme } from '../../../theme';

function OverviewFooter(props) {
    const campaigns = props.selectedCampaigns.length > 0 ? props.selectedCampaigns : props.visibleCampaigns;

    const totalCapturedValue = campaigns.reduce((acc, campaign) => acc + campaign.captured_value, 0);
    const totalOpportunityValue = campaigns.reduce((acc, campaign) => acc + campaign.opportunity_value, 0);
    const includedPhysicianIds = new Set();
    const engagedPhysicianIds = new Set();
    campaigns.forEach(campaign => {
        (campaign.physicians || []).forEach(physician => {
            includedPhysicianIds.add(physician.id);
            const summary = physician.recommendation_summary || {};
            if (summary.num_open < summary.total_recs) {
                engagedPhysicianIds.add(physician.id);
            }
        });
    });
    const totalEngagedPhysicians = engagedPhysicianIds.size;
    const totalIncludedPhysicians = includedPhysicianIds.size;
    const totalStaffReviewedCount = campaigns.reduce((acc, campaign) => acc + (campaign.card_manager_summary.total_approved_recs || 0), 0);
    const totalStaffOpportunityCount = campaigns.reduce((acc, campaign) => acc + (campaign.card_manager_summary.total_opportunity_recs || 0), 0);
    const totalOverdueReviews = campaigns.reduce((acc, campaign) => acc + campaign.num_overdue_reviews, 0);
    const totalOverdueValue = campaigns.reduce((acc, campaign) => acc + campaign.value_of_overdue_reviews, 0);

    return ( 
        <TableHead sx={{ bottom: 0, left: 0, position: 'sticky', zIndex: 2 }}>
            <TableRow className='tableFooter' sx={{ 
                textOverflow: 'ellipsis', 
                overflow: 'hidden', 
                color: 'black', 
                height: '60px',
            }}>
                <TableCell>
                    <Typography variant='heavy' fontSize='12px'>
                        {props.selectedCampaigns.length > 0 ? <strong>{props.selectedCampaigns.length} Selected</strong> : <strong>{props.totalCampaigns} Total</strong>}
                    </Typography>
                </TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell>-</TableCell>
                <TableCell style={{ textAlign: 'right' }}>
                    <Typography variant='heavy' fontSize='12px'>
                        <strong>
                            <NumericFormat value={totalCapturedValue/ 100} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={0} fixedDecimalScale />
                        </strong> {' / '}  
                        <NumericFormat value={totalOpportunityValue / 100} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={0} fixedDecimalScale />
                    </Typography>
                </TableCell>
                <TableCell>
                    <Tooltip title="Percentage of unique physicians who have engaged in at least one of the selected campaigns">
                        <span>
                            <MultipleProgressBar segments={[
                                {
                                    value: (totalEngagedPhysicians / Math.max(totalIncludedPhysicians, 1)) * 100,
                                    color: `${theme.palette.blue.main}`
                                },
                                {
                                    value: (100 - (totalEngagedPhysicians / Math.max(totalIncludedPhysicians, 1)) * 100),
                                    color: `${theme.palette.background.unreviewedProgress}`
                                }
                            ]} label={`${Math.round((totalEngagedPhysicians / Math.max(totalIncludedPhysicians, 1)) * 100)}%`} />
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell>
                    <Tooltip title="Percentage of card manager reviewed optimizations out of all optimizations in selected campaigns (based on number of optimizations)">
                        <span>
                            <MultipleProgressBar segments={[
                                {
                                    value: (totalStaffReviewedCount / Math.max(totalStaffOpportunityCount, 1)) * 100,
                                    color: `${theme.palette.blue.main}`
                                },
                                {
                                    value: (100 - (totalStaffReviewedCount / Math.max(totalStaffOpportunityCount, 1)) * 100),
                                    color: `${theme.palette.background.unreviewedProgress}`
                                }
                            ]} label={`${Math.round((totalStaffReviewedCount / Math.max(totalStaffOpportunityCount, 1)) * 100)}%`} />
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell style={{ textAlign: 'right' }}>
                    <OverdueChip numOverdue={totalOverdueReviews} overdueValue={totalOverdueValue} />
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

export default OverviewFooter;
